import { defaultFormItemLayout } from '../../../../../modules/FormItems'
import React from 'react'
import { Col, Form, Row } from 'antd'
import { strVal } from '../../../../../modules/Utils'

function PayrollClaimLineForm (props) {
  const { line } = props

  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Amount'}>
            <span>{strVal(line, 'amount')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Currency'} {...defaultFormItemLayout}>
            <span>{strVal(line, 'bank.currency')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Account Name'} {...defaultFormItemLayout}>
            <span>{strVal(line, 'bank.accname')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Bank Name'} {...defaultFormItemLayout}>
            <span>{strVal(line, 'bank.bank.name')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Account Number'} {...defaultFormItemLayout}>
            <span>{strVal(line, 'bank.number')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Swift'} {...defaultFormItemLayout}>
            <span>{strVal(line, 'bank.bank.swift')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Bank Address'} {...defaultFormItemLayout}>
            <span>{strVal(line, 'bank.bank.address')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Country'} {...defaultFormItemLayout}>
            <span>{strVal(line, 'bank.bank.country')}</span>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label={'Code'} {...defaultFormItemLayout}>
            <span>{strVal(line, 'bank.bank.code')}</span>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

PayrollClaimLineForm.propTypes = {}
PayrollClaimLineForm.defaultProps = {}

export default Form.create()(PayrollClaimLineForm)
